import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SharedApiService, ApiType } from '../../../../../libs/shared/src/lib/services/api.service';
import { Company } from '../models/company.model';

interface CompaniesResponse {
  companies: Company[];
  limit: number;
  page: number;
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  constructor(private sharedApiService: SharedApiService) {}

  /**
   * Get all companies with open positions
   */
  getCompanies(
    limit: number = 12,
    offset: number = 0,
    searchKeyword: string = ''
  ): Observable<{ companies: Company[]; total: number }> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('limit', limit.toString());
    queryParams = queryParams.append('offset', offset.toString());

    if (searchKeyword) {
      queryParams = queryParams.append('name', searchKeyword);
    }

    return this.sharedApiService
      .get<CompaniesResponse>('api/companies', queryParams, {
        apiType: ApiType.OPEN,
        jobsRequest: true,
      })
      .pipe(
        map((response) => ({
          companies: response.companies || [],
          total: response.total || 0,
        })),
        catchError((error) => {
          console.error('Error fetching companies:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Get a single company by ID
   */
  getCompanyById(id: number): Observable<Company | undefined> {
    return this.sharedApiService
      .get<Company>(`api/companies/${id}`, undefined, {
        apiType: ApiType.OPEN,
        jobsRequest: true,
      })
      .pipe(
        catchError((error) => {
          console.error(`Error fetching company with ID ${id}:`, error);
          return throwError(() => error);
        })
      );
  }
}
